import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	addItem: {
		id: 'navigation-apps-shortcuts-sidebar.add-item',
		defaultMessage: 'Add shortcut',
		description: 'Add shortcut copy for the button',
	},
});
